import { render } from "./PersonalArea.vue?vue&type=template&id=63424b57&scoped=true"
import script from "./PersonalArea.vue?vue&type=script&lang=js"
export * from "./PersonalArea.vue?vue&type=script&lang=js"

import "./PersonalArea.vue?vue&type=style&index=0&id=63424b57&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63424b57"]])

export default __exports__